@import '~ss-ui-client/src/constants/spacing.module.less';

.modalBody {
  padding: @space-16;
}
